import { Component, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent  implements OnInit {

  /**
   * Variables
   */
  PilotForm: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the pilot form.
   */
  ngOnInit() {
    this.PilotForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}
